import { Dropdown } from '@joor/design-system'
import styled, { css } from 'styled-components'

export const StyledDropdown = styled(Dropdown)<{
  newCustomerOptionId?: string
}>`
  max-width: 440px;

  input {
    font-size: var(--size-font-small) !important;
  }

  ${({ newCustomerOptionId }) =>
    newCustomerOptionId &&
    css`
      #${CSS.escape(newCustomerOptionId)} {
        color: var(--color-secondary-800) !important;
      }
    `}
`

export const DropdownContainer = styled.div`
  margin-bottom: 14px;
`
